import { Component } from '@theme/component';

const DEFAULT_WORDS_PER_MINUTE = 200;

/**
 * Estimates reading time client-side by counting words in the nearest
 * article content element, rather than computing it server-side in Liquid.
 */
class ReadingTimeEstimate extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#render();
  }

  #render() {
    const selector = this.dataset.contentSelector || '.blog-post-content';
    const contentElement = document.querySelector(selector);
    if (!contentElement) return;

    const text = contentElement.innerText || contentElement.textContent || '';
    const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
    if (!wordCount) return;

    const wordsPerMinute = Number(this.dataset.wpm) || DEFAULT_WORDS_PER_MINUTE;
    const minutes = Math.max(1, Math.round(wordCount / wordsPerMinute));
    const template = this.dataset.template || '%minutes% min read';

    this.textContent = template.replace('%minutes%', String(minutes));
    this.hidden = false;
  }
}

if (!customElements.get('reading-time-estimate')) {
  customElements.define('reading-time-estimate', ReadingTimeEstimate);
}
